module.exports = __webpack_public_path__ + "fonts/3107C8_0_0.f7308f7.eot";